import { FinanceFilterNS } from "../finance/models/finance-filter.model";

export enum ObjectTypeId {
    Lead = 1,
    Account = 2,
    Cases = 8
}

export enum ObjectNames {
    CHANNEL_TYPE_NAME = "Channel",
    TEMPLATE_TYPE_NAME = "Template",
    PIPELINE_TYPE_NAME = "Pipeline",
    COLUMN_SETTING_TYPE="ColumnSettings",

    CONTACTS_EMAIL_TYPES = "Contacts Email Types",
    CONTACTS_PHONE_TYPES = "Contacts Phone Types",
    CONTACTS_SOCIAL_TYPES = "Contacts Social Types",
    CONTACT_TEMPLATE = "Contact Template",
    CONTACT_COLUMN_SETTINGS = "Contact Column Settings",

    DASHBOARD ="Dashboard",
    STREAM ="Stream",

    COMPANY_DETAILS ="Company And Location",
    PRIVACY="Privacy",
    ROLE ="Roles",
    USER ="Users",
    MOBILE_APP="MobileApp",
    WEB="Web",
    NOTIFICATION="Notification",
    TEMPLATE="Template",
    GLOBAL="Global",
    SAVED="Saved",
    DUPLICATE="Duplicate",
    SERIES="Series",
    ACTIVITY ="Activity",

    ACCOUNT ="Account",
    CONTACT="Contact",
    TERRITORY="Territory",
    TERRITORY_CONFIGURATION="Territory Configuration",
    TRANSACTIONS = "Transactions",
    QUESTIONNAIRE = "Questionnaire",
    GOAL = "Goal",
    LEAD ="Lead",
    LEADS ="Leads",
    OPPORTUNITY="Opportunity",
    LEAD_LIFE_CYCLE_STAGE = "Lead Life Cycle Stage",
    ROUTE="Route",
    SavedSearch = "SavedSearch",
    SavedSearchAnalytics = "SavedSearchAnalytics",
    WORKFLOW = 'WorkFlow',
    WORKSPACES = 'Workspaces',
    CAMPAIGN = 'Messaging',
    C_SETTING = "C-Setting",

    F_SETTING = "FSetting",
    FINANCE="Finance",
    FINANCE_SETUP="Finance SetUp",

    Inventory_Item = 'Inventory Item',
    Bundle_Item = 'Bundle Item',
    Non_Inventory_Item = 'Non Inventory Item',
    Service_Item = 'Service',
    Kit_Items = 'Kit/Package Items',

    QUOTATION ="Quotation",
    SALES_ORDER = "SalesOrder",
    BILL_ORDER = "BillOrder",
    CREDIT_MEMO = "credit-memo",
    CREDIT_RMA = "customer-returns",
    INVOICE = "Invoice",
    ESTIMATE = "estimates",
    PRODUCT = "Product",
    RETURN = 'Return',
    LOCATION = "Location",
    INVENTORY_SETUP="Inventory SetUp",
    QUANTITY="Quantity",
    ORDER="SalesOrder",
    CUSTOM="Custom",
    CUSTOM_RULES="CustomRules",
    CUSTOMERS="Customers",
    I_SETTING="I-Setting",
    CustomerRMA = "Customer RMA",
    CM_Menu_Object = "Credit Memo",
    SALES_RECEIPT = "Sales Receipt",
    Est_Menu_Object = "Estimate",
    Import_Export = "ImportExport",
    Approvals = "Approvals",
    RECEIVE_PAYMENT = "Receive Payment",
    JOURNAL = "Journal",
    BANK_REGISTER = "Bank Register",
    CHECK = "Check",
    CREDIT_CHARGES = "Credit Charges",
    EXPENSE = "Expense",
    TASK_CATEGORY = "Task Category",

    PURCHASE = "Purchases",
    Item_Receipt = "Item Receipt",
    Bill = "Bill",
    Bill_Payment = "BillPayment",
    Vendor = "Vendor",
    Vendor_Returns = "VendorReturns",
    Vendor_Credit = "VendorCredit",
    WAREHOUSE = "Warehouse",
    LEAVE_MANAGEMENT ="Leave Management",
    TASK = "Task",
    CONFIGURATION ="Configuration",

    CASES="Cases",
    CASES_LIFE_CYCLE_STAGE = "Cases Life Cycle Stage",
    CASE_COLUMN_SETTINGS = "Case Column Settings",
    CRM_CUSTOM ="CRM Custom",

    LEAD_EMAIL_TYPES = "Lead Email Types",
    LEAD_PHONE_TYPES = "Lead Phone Types",
    LEAD_SOCIAL_TYPES = "Lead Social Types",
    LEAD_CHANNEL = "Lead Channel",
    LEAD_TEMPLATE = "Lead Template",
    LEAD_COLUMN_SETTINGS = "Lead Column Settings",

    ACCOUNT_EMAIL_TYPES = "Account Email Types",
    ACCOUNT_PHONE_TYPES = "Account Phone Types",
    ACCOUNT_SOCIAL_TYPES = "Account Social Types",
    ACCOUNT_GROUPS = "Account Groups",
    ACCOUNT_CHANNEL = "Account Channel",
    ACCOUNT_TEMPLATE = "Account Template",
    ACCOUNT_COLUMN_SETTINGS = "Account Column Settings",


    FIELD_CASES_CONFIGURATION = "Field Data Cases Configuration",
    CHANNEL_CASES_CONFIGURATION = "Channel Cases Configurtion",
    CHANNEL_STAGE_CONFIGURATION = "Channel Stage Configurtion",
    TEMPLATE_CASES_CONFIGURATION = "Template Cases Configuration",
    USER_TEMPLATE = "User Template",
    ROLE_TEMPLATE = "Role Template",

    FIELD_PRODUCT_CONFIGURATION = "Product Template",
    CHANNEL_PRODUCT_CONFIGURATION = "Product Type",
    TEMPLATE_PRODUCT_CONFIGURATION = "Product Template",
    SECTION_PRODUCT_CONFIGURATION  = "Product Section",
    // USER_TEMPLATE = "User Template",
    // ROLE_TEMPLATE = "Role Template",

    OPPORTUNITY_PIPELINE = "Opportunity Pipeline",
    OPPORTUNITY_STAGES = "Opportunity Stages",
    OPPORTUNITY_TEMPLATE = "Opportunity Template",
    OPPORTUNITY_LIFE_CYCLE_STAGE = "Opportunity Life Cycle Stage",
    OPPORTUNITY_COLUMN_SETTINGS = "Opportunity Column Settings",

    ROUTE_COLUMN_SETTINGS = "Route Column Settings",

    TERRITORY_COLUMN_SETTINGS = "Territory Column Settings",

    QUESTIONNAIRE_TEMPLATE = "Questionnaire Template",

    DASHBOARD_USER_SETTINGS = "Dashboard",

    ACCOUNTING = "AccountingInvoicingIntegration",
    BOSTS = "Bots & Messaging",
    CALENDAR = "Contact & Calendar sync",
    EMAIL = "Email Marketing",
    LEADGENERATION = "Lead Generation",
    PROPOSAL = "Proposals & Contracts",
    ECOMMERCE = "Ecommerce",
    SMTP = "SMTP",
    VendorSMTPRegistration = 'VendorSMTPRegistration',
    POS = "Point of Sale",

    LABEL_CONTACT = "Label Contact",
    CONTACT_DETAILS = "Contact Details",
    LABEL_INFO = "Label Info",
    ACCOUNT_INFORMATION = "Account Information",
    LABEL_BUSINESS = "Label Business",
    ACCOUNT_DETAILS = "Account Details",
    LABEL_ADDRESS = "Label Address",
    ADDRESS_DETAILS = "Address Details",
    ACCOUNT_EMAIL = "account email",
    ACCOUNT_PHONE = "account phone",
    ACCOUNT_SOCIAL = "account social",

    email = "email",
    phone = "phone",
    main = "main",
    social = "social",
    pointOfSale = "PointOfSale",
    serialDetails = "SerialDetails",
    activationDetails = 'Activation',
    residualDetails = 'Residual',
    commissionDetails = 'Commission',
    spiffDetails = 'Spiff'
}

export const salesOrderModuleObjectNames : string[]  = [
    ObjectNames.SALES_ORDER,
    ObjectNames.Est_Menu_Object,
    ObjectNames.INVOICE,
    ObjectNames.CustomerRMA,
    ObjectNames.CM_Menu_Object,
    ObjectNames.RECEIVE_PAYMENT
];

export const purchasesModuleObjectNames : string[]  = [
    ObjectNames.PURCHASE,
    ObjectNames.Item_Receipt,
    ObjectNames.Bill,
    ObjectNames.Bill_Payment,
    ObjectNames.Vendor,
    ObjectNames.Vendor_Returns,
    ObjectNames.Vendor_Credit
];

export const productsModuleObjectNames : string[]  = [
    ObjectNames.Inventory_Item,
    ObjectNames.Bundle_Item,
    ObjectNames.Non_Inventory_Item,
    ObjectNames.Service_Item,
    ObjectNames.Kit_Items
];

export const serialDetailModuleObjectNames : string[]  = [
    ObjectNames.serialDetails,
    ObjectNames.activationDetails,
    ObjectNames.residualDetails,
    ObjectNames.commissionDetails,
    ObjectNames.spiffDetails
];
export const ReconcilationReportCols = [
    { field: 'refno', header: 'Ref No', name: 'Ref No', show: true, value: '', checked: true, order: false, dataType: "String", operators: FinanceFilterNS.FilterDataTypeWithOperator.filter(x => x.DataType === "Number").map(x => x.Operator), formControlType: "InputBox", fieldDataType: "String", columnName: 'refno' },
    { field: 'number', header: 'Number', name: 'Number', show: true, value: '', checked: true, order: false, dataType: "String", operators: FinanceFilterNS.FilterDataTypeWithOperator.filter(x => x.DataType === "Money").map(x => x.Operator), formControlType: "InputBox", fieldDataType: "String", columnName: 'number' },
    { field: 'date', header: 'Date', name: 'Date', show: true, value: '', checked: true, order: false, dataType: "DateTime", operators: FinanceFilterNS.FilterDataTypeWithOperator.filter(x => x.DataType === "DateTime").map(x => x.Operator), formControlType: "InputBox", fieldDataType: "DateTime", columnName: 'date' },
    { field: 'accountname', header: 'Account Name', name: 'Account Name', show: true, value: '', checked: true, order: false, dataType: "String", operators: FinanceFilterNS.FilterDataTypeWithOperator.filter(x => x.DataType === "String").map(x => x.Operator), formControlType: "InputBox", fieldDataType: "String", columnName: 'accountname' },
    { field: 'amount', header: 'Paid Amount', name: 'Paid Amount', show: true, value: '', checked: true, order: false, dataType: "Decimal", operators: FinanceFilterNS.FilterDataTypeWithOperator.filter(x => x.DataType === "String").map(x => x.Operator), formControlType: "InputBox", fieldDataType: "Decimal", columnName: 'amount' },
    { field: 'term', header: 'Payment Term', name: 'Payment Term', show: true, value: '', checked: true, order: false, dataType: "String", operators: FinanceFilterNS.FilterDataTypeWithOperator.filter(x => x.DataType === "String").map(x => x.Operator), formControlType: "InputBox", fieldDataType: "String", columnName: 'term' },
    { field: 'method', header: 'Payment Method', name: 'Payment Method', show: true, value: '', checked: true, order: false, dataType: "String", operators: FinanceFilterNS.FilterDataTypeWithOperator.filter(x => x.DataType === "String").map(x => x.Operator), formControlType: "InputBox", fieldDataType: "String", columnName: 'term' },
];
export const imageTypes: string[] = ['png', 'jpeg', 'gif', 'jpg'];

export const googleViewerFiles: string[] = ['pdf', 'csv', 'txt'];
